import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

import { Goal } from 'types';

const DEFAULT_GOAL_PROPS = {
    id: null,
    name: '',
    description: '',
    access_type: 'public',
    end_date: null
};

export const createGoal = (goalProps: Partial<Goal>) => {
    return dispatchPromise({
        type: 'GOAL_CREATE_REQUESTED',
        payload: {
            goal: Object.assign({}, DEFAULT_GOAL_PROPS, goalProps, {
                id: uuidv4()
            })
        }
    });
}

export const fetchGoals = (all?: boolean) => fetchResources('GOALS_FETCH_REQUESTED', {}, all);

export const fetchGoal = (goalId: string) => {
    return dispatchPromise({
        type: 'GOAL_FETCH_REQUESTED',
        payload: { goalId }
    });
}

export const updateGoal = (goalId: string, goalProps: Partial<Goal>, preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_UPDATE_REQUESTED',
        preventSave,
        payload: {
            goalId,
            goalProps
        }
    });
}

export const assignUsers = (goalId: string, users: string[], preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_ASSIGN_REQUESTED',
        preventSave,
        payload: {
            goalId,
            users
        }
    });
}

export const unassignUsers = (goalId: string, users: string[], preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_UNASSIGN_REQUESTED',
        preventSave,
        payload: {
            goalId,
            users
        }
    });
}

export const tieTasks = (goalId: string, taskIds: string[], preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_TIE_TASKS_REQUESTED',
        preventSave,
        payload: {
            goalId,
            taskIds
        }
    });
}

export const untieTasks = (goalId: string, taskIds: string[], preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_UNTIE_TASKS_REQUESTED',
        preventSave,
        payload: {
            goalId,
            taskIds
        }
    });
}

export const tieMilestones = (goalId: string, milestoneIds: string[], preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_TIE_MILESTONES_REQUESTED',
        preventSave,
        payload: {
            goalId,
            milestoneIds
        }
    });
}

export const untieMilestones = (goalId: string, milestoneIds: string[], preventSave?: boolean) => {
    return dispatchPromise({
        type: 'GOAL_UNTIE_MILESTONES_REQUESTED',
        preventSave,
        payload: {
            goalId,
            milestoneIds
        }
    });
}

export const removeGoal = (goalId: string) => {
    return dispatchPromise({
        type: 'GOAL_REMOVE_REQUESTED',
        payload: {
            goalId
        }
    });
}
